/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Unavailable_TitleInputs */

const en_pc_online_unavailable_title = /** @type {(inputs: Pc_Online_Unavailable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft Online is being set up`)
};

const zh_pc_online_unavailable_title = /** @type {(inputs: Pc_Online_Unavailable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 在线版正在部署中`)
};

/**
* | output |
* | --- |
* | "PdfCraft Online is being set up" |
*
* @param {Pc_Online_Unavailable_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_unavailable_title = /** @type {((inputs?: Pc_Online_Unavailable_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Unavailable_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_unavailable_title(inputs)
	return zh_pc_online_unavailable_title(inputs)
});
export { pc_online_unavailable_title as "pc.online.unavailable_title" }